import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect } from "react";
import { applyTheme } from "./applyTheme";
const ThemeContext = createContext(null);
export function ThemeProvider({ theme, children }) {
    useEffect(() => {
        applyTheme(theme);
    }, [theme]);
    return _jsx(ThemeContext.Provider, { value: theme, children: children });
}
export function useTheme() {
    const ctx = useContext(ThemeContext);
    if (!ctx) {
        throw new Error("useTheme() must be used inside <ThemeProvider>");
    }
    return ctx;
}
//# sourceMappingURL=ThemeProvider.js.map